import React, { useEffect, useState } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import { GetAllFAQ } from "../../../website/services/website.services";
import NoDataFound from "../../shared/NoDataFound";

const HOME_FAQ_COUNT = 5;

function FaqItem({ item, isOpen, onToggle }) {
  return (
    <div className="border border-gray-200 bg-white rounded-[20px] overflow-hidden transition-all duration-300">
      <button
        className="flex justify-between items-start w-full p-4 md:p-6 text-left focus:outline-none"
        onClick={onToggle}
      >
        <span
          className={`web-h5 transition-colors duration-300 ${
            isOpen ? "text-gray-900" : "text-gray-700 hover:text-gray-900"
          }`}
        >
          {item.title}
        </span>
        <div className="ml-4 flex-shrink-0">
          {isOpen ? (
            <FiMinus className="w-5 h-5 text-yellow-600" />
          ) : (
            <FiPlus className="w-5 h-5 text-gray-500" />
          )}
        </div>
      </button>
      <div
        className={`grid transition-all duration-500 ease-in-out ${
          isOpen
            ? "grid-rows-[1fr] opacity-100 p-4 pt-0 md:p-6 md:pt-0"
            : "grid-rows-[0fr] opacity-0 p-0"
        }`}
      >
        <div className="overflow-hidden">
          <div
            className="text-gray-600 web-body-md !leading-relaxed"
            dangerouslySetInnerHTML={{ __html: item.description || "" }}
          />
        </div>
      </div>
    </div>
  );
}

function FaqSection() {
  const [faqItems, setFaqItems] = useState([]);
  const [openItemId, setOpenItemId] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    GetAllFAQ()
      .then((response) => {
        const rawList = response?.data?.list;
        const list = Array.isArray(rawList)
          ? rawList.filter((item) => item?.title)
          : [];
        setFaqItems(list);
        setOpenItemId(list[0]?._id || null);
      })
      .catch((error) => {
        console.log("Error===>", error);
        setFaqItems([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const visibleItems = showAll ? faqItems : faqItems.slice(0, HOME_FAQ_COUNT);
  const hasMore = faqItems.length > HOME_FAQ_COUNT;

  return (
    <section id="faq" className="faq-section py-10 md:py-16 relative overflow-hidden">
      <div className="container">
        <div className="max-w-[950px] mx-auto text-center mb-8 md:mb-12">
          <span className="inline-flex items-center gap-2 tracking-[.2em] body-lg">
            <span className="w-[33px] h-[1px] bg-primary-500 inline-block"></span>
            FAQ
          </span>
          <h2 className="web-h2 text-zinc-900 mt-3">
            Frequently Asked Questions
          </h2>
          <p className="web-body-sm text-zinc-600 mt-2">
            From energized beads to sacred pujas, discover remedies designed
            for harmony and growth.
          </p>
        </div>

        <div className="faq-bg">
          {isLoading ? (
            <p className="text-center text-gray-500 web-body-md">Loading FAQs...</p>
          ) : visibleItems.length ? (
            <div className="space-y-4">
              {visibleItems.map((item) => (
                <FaqItem
                  key={item._id}
                  item={item}
                  isOpen={openItemId === item._id}
                  onToggle={() =>
                    setOpenItemId(openItemId === item._id ? null : item._id)
                  }
                />
              ))}
            </div>
          ) : (
            <NoDataFound
              title="No Data Found"
              message="No FAQs are available right now. Please check back later."
            />
          )}

          {hasMore && (
            <div className="mt-8 flex justify-center">
              <button
                type="button"
                className="custom-btn custom-btn-primary"
                onClick={() => setShowAll((prev) => !prev)}
              >
                {showAll ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
